// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type OnboardingFlowCompletedResponse = {
	completed: boolean;
};

export const onboardingFlowCompletedResource: RouteResource<OnboardingFlowCompletedResponse> =
	createResource<OnboardingFlowCompletedResponse>({
		type: 'ONBOARDING_FLOW_COMPLETED_RESOURCE',
		getKey: () => 'onboarding_flow_completed',
		getData: async () => {
			try {
				const response = await performGetRequest<OnboardingFlowCompletedResponse>(
					'/rest/onboarding/1.0/flow/completed',
				);

				return {
					completed: response.completed,
				};
			} catch (err) {
				const normalizedError = err instanceof Error ? err : new Error(JSON.stringify(err));

				fireErrorAnalytics({
					meta: {
						id: 'onboardingFlowCompleted.resourceError',
						packageName: 'jiraRouterResourcesJswOnboarding',
						teamName: 'jlove-makkuro',
					},
					attributes: {
						action: 'fetchOnboardingFlowCompleted',
					},
					error: normalizedError,
				});

				// Default to true if the request fails to avoid users completing onboarding multiple times
				return {
					completed: true,
				};
			}
		},
		maxAge: 0,
	});

export const useOnboardingFlowCompletedResource =
	(): UseResourceHookResponse<OnboardingFlowCompletedResponse> =>
		useResource<OnboardingFlowCompletedResponse>(onboardingFlowCompletedResource);
